import React, { useEffect, useMemo, useState } from 'react'
import { InputHTMLAttributes, ReactChild } from 'react'
import { DolaThemes } from '../../styles/types'
import { generate } from 'shortid'
import { Error, FauxInput, Input, InputWrapper, Label, Mask } from './styles'
import { P } from '../../styles/Elements'

export interface TextFieldProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'placeholder'> {
  error?: ReactChild
  label: ReactChild
  mask?: ReactChild
  placeholder?: ReactChild
  theme?: DolaThemes
}

export type InputModes = 'default' | 'error' | 'active'

const DolaInput: React.FC<TextFieldProps> = ({
  error,
  label,
  mask,
  onBlur,
  placeholder,
  theme = 'light',
  ...props
}) => {
  const [active, setActive] = useState(false)
  const [moveLabelToBorder, setMoveLabelToBorder] = useState(
    !!(props.value || mask)
  )
  const [flagErrors, setFlagErrors] = useState(false)

  useEffect(() => {
    if (active) {
      setMoveLabelToBorder(true)
    } else if (!(props.value || mask)) {
      setMoveLabelToBorder(false)
    }
  }, [active])

  let mode: InputModes = 'default'

  if (active) {
    mode = 'active'
  }

  if (error && flagErrors) {
    mode = 'error'
  }

  const id = useMemo(() => generate(), [])

  return (
    <div>
      <FauxInput dolaTheme={theme} mode={mode}>
        <InputWrapper>
          <Label
            htmlFor={id}
            toBorder={moveLabelToBorder}
            mode={mode === 'default' && moveLabelToBorder ? 'active' : mode}
            dolaTheme={theme}
          >
            <span>{moveLabelToBorder ? label : placeholder || label}</span>
          </Label>
          {mask && (
            <Mask>
              <P>{mask}</P>
            </Mask>
          )}
          <Input
            dolaTheme={theme}
            id={id}
            mode={mode}
            onBlur={async (e: React.FocusEvent<any>) => {
              setActive(false)

              if (!flagErrors) {
                setFlagErrors(true)
              }

              if (onBlur) {
                onBlur(e)
              }
            }}
            onFocus={() => {
              setActive(true)
            }}
            {...props}
          />
        </InputWrapper>
      </FauxInput>
      {mode === 'error' && (
        <Error dolaTheme={theme} mode={mode}>
          <P className="error-text">{error}</P>
        </Error>
      )}
    </div>
  )
}

export default DolaInput
